<template>
  <div>
    <span v-if="action && action.assignee && user">
      <span v-if="action.assignee.id === user.id">
        <i class="fa fa-clock orange"></i>
      </span>
      <span v-else>
      <i class="fa fa-remove red" style="opacity: 30%;" v-if="action && action.status === 'waiting'"></i>
      <i class="fa fa-clock orange" style="opacity: 30%;" v-if="action && action.status === 'started'" :title="action.startTime.date ? $moment(action.startTime.date).fromNow() : '?'"></i>
      <i class="fa fa-check green" style="opacity: 30%;" v-if="action && action.status === 'completed'" :title="action.endTime.date ? $moment(action.endTime.date).fromNow() : '?'"></i>
      <i class="fa fa-ban green" style="opacity: 30%;" v-if="!action || action.status === 'na'"></i>
      </span>
    </span>
    <span v-else>
      <i class="fa fa-remove red" v-if="action && action.status === 'waiting'"></i>
      <i class="fa fa-clock orange" v-if="action && action.status === 'started'" :title="action.startTime.date ? $moment(action.startTime.date).fromNow() : '?'"></i>
      <i class="fa fa-check green" v-if="action && action.status === 'completed'" :title="action.endTime.date ? $moment(action.endTime.date).fromNow() : '?'"></i>
      <i class="fa fa-ban grey" v-if="!action || action.status === 'na'"></i>
    </span>
  </div>
</template>
<script>
export default {
  props: ['action', 'user']
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Pbn/Build/List/Actions.vue